export default {
    mustRegex: {
        contractions: [`n't required`],
        sentences: ['not required'],
    },
    experienceRegex: {
        contractions: [`n't be experienced`, `n't experienced`],
        sentences: [
            'no experience',
            'not be experienced',
            'not experienced',
            'user experience',
            'customer experience',
            'candidate experience',
            'onboarding experience',
            '75 years',
            '76 years',
        ],
    },
}
